import { render, staticRenderFns } from "./abnormalFollowModal.vue?vue&type=template&id=06800572&scoped=true"
import script from "./abnormalFollowModal.vue?vue&type=script&lang=js"
export * from "./abnormalFollowModal.vue?vue&type=script&lang=js"
import style0 from "./abnormalFollowModal.vue?vue&type=style&index=0&id=06800572&prod&lang=scss&scoped=true"
import style1 from "./abnormalFollowModal.vue?vue&type=style&index=1&id=06800572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06800572",
  null
  
)

export default component.exports